
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-427f8d8a\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./404.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-427f8d8a\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./404.vue"),
  /* scopeId */
  "data-v-427f8d8a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/404.vue
// module id = 589
// module chunks = 1